// src/app/core/services/url-normalizer.service.ts
import { Injectable } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class UrlNormalizerService {
  constructor(private router: Router) {}

  init() {
    this.router.events.pipe(
      filter(event => event instanceof NavigationStart)
    ).subscribe((event: NavigationStart) => {
      const normalizedUrl = this.normalizeUrl(event.url);
      if (normalizedUrl !== event.url) {
        this.router.navigateByUrl(normalizedUrl, { replaceUrl: true });
      }
    });
  }

  private normalizeUrl(url: string): string {
    // Remove /PartnerPortal/ segment
    url = url.replace(/\/PartnerPortal\//i, '/');
    
    // Remove hash and everything before it if it exists
    const hashIndex = url.indexOf('#');
    if (hashIndex > -1) {
      url = url.substring(hashIndex + 1);
    }
    
    // Ensure leading slash
    if (!url.startsWith('/')) {
      url = '/' + url;
    }
    
    return url;
  }
}